import { createElement, emptyNode, getFormByElement} from "autosuggest-helpers";

const maxSuggestions = 10;

class AutoSuggestContainer {
    constructor(el, target) {
        this.max = maxSuggestions;
        this.node = el;
        this.target = target;
        this.form = getFormByElement(this.target);
        this.preventFocusOutEvent = false;

        for (let type of ['mouseover', 'mouseout']) {
            this.node.addEventListener(type, this);
        }
    }

    /**
     * append
     * @param {string} str 
     */
    append(str) {
        if (this.node.childNodes.length < this.max) {
            let item = createElement(str);
            let _this = this;

            ['click', 'mousedown', 'keydown'].forEach(type => {
                item.querySelector('a').addEventListener(type, _this);
            });

            this.node.appendChild(item);
        }
    }

    /**
     * handleEvent
     * @param {object} event 
     */
    handleEvent(event) {
        switch (event.type) {
            case "click":
                this.handleSelection(event);
                break;
            case "mouseout":
                this.preventFocusOutEvent = false;
                break;
            case "mouseover":
                this.preventFocusOutEvent = true;
                break;
            case "keydown":
                if (event.key == "ArrowDown" || event.key == "ArrowUp") {
                    event.preventDefault();
                    this.handleArrowKey(event);
                }
        }
    }

    /**
     * handleArrowKey
     * @param {object} event 
     */
    handleArrowKey(event) {
        switch (event.key) {
            case "ArrowDown":
                if (event.currentTarget.parentNode.nextSibling !== null) {
                    event.currentTarget.parentNode.nextSibling.querySelector("a").focus();
                } else {
                    this.node.childNodes[0].querySelector("a").focus();
                }
                break;
            case "ArrowUp":
                if (event.currentTarget.parentNode.previousSibling !== null) {
                    event.currentTarget.parentNode.previousSibling.querySelector("a").focus();
                } else {
                    this.node.childNodes[this.node.childNodes.length - 1].querySelector("a").focus();
                }
                break;
        }
    }

    /**
     * handleSelection
     * @param {object} event 
     */
    handleSelection(event) {
        emptyNode(this.node);
        this.target.value = event.currentTarget.innerHTML;        
        this.form.submit();
    }

    /**
     * reset
     */
    reset() {
        if (this.preventFocusOutEvent !== true) {
            emptyNode(this.node);
            this.node.classList.add('--inactive');
        }
    }

    /**
     * show
     */
    show() {
        emptyNode(this.node);
        this.node.classList.remove('--inactive');
    }
}

export default AutoSuggestContainer;